import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-td-maturity-instruction',
  templateUrl: './td-maturity-instruction.component.html',
  styleUrls: ['./td-maturity-instruction.component.css']
})
export class TdMaturityInstructionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/td-maturity-instruction/td-maturity-instruction.component.ts